import React, { useContext, useEffect, useState } from "react";
import "../../Dashboard/View_List/View_List.css";
import Delete_Points_Modal from "../../Common_Component/Common_Modal/Delete_Points_Modal/Delete_Points_Modal";
import { Button, Form, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import { findAll, Update } from "../../../utils/apis/matka/rate/rate";
import { HTTPS, Per_Page_Dropdown } from "../../../utils/common";
import Pagination_holder from "../../Common_Component/Pagination_holder/Pagination_holder";
import CustomPaginate from "../../Common_Component/CustomPaginate/CustomPaginate";
import { Context } from "../../../utils/context";
import Heading_Holder from "../../Common_Component/Heading_Holder/Heading_Holder";
import ModalSave from "../../Common_Component/Common_Modal/Successfull_Modal/ModelSave";
import { useForm } from "react-hook-form";

const Tables = () => {
  const { UnauthorizedLogOut } = useContext(Context);

  const [modalShow, setModalShow] = useState(false);
  const [modalEditShow, setModalEditShow] = useState(0);
  const [modalDeleteShow, setModalDeleteShow] = useState(false);
  const [modalTimingEditShow, setModalTimingEditShow] = useState(0);
  const [timingData, setTimingData] = useState(null);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(10);
  const [search, setSearch] = useState("");
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();

  const getDataAll = async () => {
    try {
      const response = await findAll(currentPage, perPage, search);
      await setData(response?.data?.data);
      setCurrentPage(response?.data?.data?.current_page);
      setperPage(response?.data?.data?.per_page);
      setSearch(response?.data?.data?.search_name);

      setOption(await Per_Page_Dropdown(response?.data?.data?.total));
    } catch (error) {
      console.error(error.message);
      await UnauthorizedLogOut(error);
    }
  };

  useEffect(() => {
    getDataAll();
  }, []);

  const { register, handleSubmit, reset } = useForm({
    defaultValues: {
      rates: [],
    },
  });

  const onSubmit = async (formData) => {
    const response = await Update(formData);

    await setShowModal({
      code: response.data?.code,
      message: response.data.data,
    });
    setTimeout(() => {
      setShowModal(0);
    }, 1000);
  };

  useEffect(() => {
    reset({
      rates: data.map((item) => ({
        id: item.id,
        rate: item.rate,
      })),
    });
  }, [data]);

  return (
    <>
      <section className="View_List">
        <Heading_Holder headingText={"Game Rates"} />

        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                {data?.map((item, index) => (
                  <div className="col-lg-6 mb-3" key={item.id}>
                    <div className="row">
                      <div className="col-6">
                        <Form.Group>
                          <Form.Label className="text text-white">
                            {item.MatkaGame?.name}
                          </Form.Label>
                          <Form.Control value={item.MatkaGame?.name} readOnly />
                        </Form.Group>
                      </div>

                      <div className="col-6">
                        <Form.Group>
                          <Form.Label className="text text-white">
                            Rate Points (10)
                          </Form.Label>

                          <input
                            type="hidden"
                            {...register(`rates.${index}.id`)}
                            defaultValue={item.id}
                          />

                          <Form.Control
                            type="number"
                            defaultValue={item.rate}
                            {...register(`rates.${index}.rate`, {
                              required: true,
                            })}
                          />
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                ))}

                <div className="col-12 mt-3">
                  <Button type="submit">Submit</Button>
                </div>
              </div>
            </Form>
          </div>
        </div>
        <ModalSave
          message={showModal.message}
          showErrorModal={showModal.code ? true : false}
        />
      </section>
    </>
  );
};

export default Tables;
